import _toConsumableArray from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

var _NotificationFilter;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Avatar, Box, HStack, IconButton, Menu, MenuButton, MenuItem, MenuList, Stack, Text, Tooltip } from '@chakra-ui/react';
import { services } from '@cofit/api';
import { Button } from '@cofit/components';
import { useVirtualizer } from '@tanstack/react-virtual';
import { useInfiniteQuery, useMutation, useQuery } from '@tanstack/react-query';
import { useRouter } from 'next/router';
import * as R from 'ramda';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ClientProfileTabType, MenuID } from 'src/types';
import { getHumanizedDateFromNow } from 'src/utils/date';
import { NOTE_PAGE_MODE } from './ClientProfiles/DietRecord/utils';
import { NotificationIcon } from './common/Icons';
import TitleHeader from './common/TitleHeader';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var getAssetType = function getAssetType(recordType) {
  return {
    'Consulting::FoodRecordPhoto': 'foodRecordPhoto',
    'Consulting::FoodRecordNote': 'foodRecordNote',
    'Note::Asset': 'noteAsset',
    Note: 'note'
  }[recordType];
};

var getAssetParentType = function getAssetParentType(recordType) {
  return {
    'Consulting::FoodRecordPhoto': 'foodRecord',
    'Consulting::FoodRecordNote': 'foodRecord',
    'Note::Asset': 'note'
  }[recordType];
};

var getAssets = R.map(function (notification) {
  var light = notification.light,
      recordType = notification.record_type,
      _parentDate = notification.record_diary_date,
      _parentId = notification.record_parent_id,
      id = notification.record_id,
      url = notification.image_url,
      text = notification.record_text;

  if (_parentDate) {
    return _objectSpread(_objectSpread({}, notification), {}, {
      asset: {
        id: id,
        url: url,
        recordType: recordType,
        text: text,
        light: light,
        _parentId: _parentId,
        _parentDate: _parentDate,
        _type: getAssetType(recordType),
        _parentType: getAssetParentType(recordType)
      }
    });
  }

  return _objectSpread(_objectSpread({}, notification), {}, {
    asset: {
      id: id,
      url: url,
      recordType: recordType
    }
  });
});
export var NotificationFilterKeys = {
  ALL: 'all',
  UNREAD: 'unread'
};
export var NotificationFilter = (_NotificationFilter = {}, _defineProperty(_NotificationFilter, NotificationFilterKeys.ALL, 'all'), _defineProperty(_NotificationFilter, NotificationFilterKeys.UNREAD, 'unread'), _NotificationFilter);
var getNextPageParam = R.path([-1, 'created_at']);
var ONE_MINUTE = 60000;

var NotificationBadge = function NotificationBadge(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_jsx(Stack, {
    pos: "absolute",
    top: "-1",
    right: "-1",
    bgColor: "#EA5455",
    rounded: "full",
    w: "6",
    h: "6",
    alignContent: "center",
    justifyContent: "center",
    e2eid: "components_NotificationMenuWithTriggerButton_Stack",
    children: /*#__PURE__*/_jsx(Text, {
      color: "white",
      textAlign: "center",
      fontSize: "xs",
      e2eid: "components_NotificationMenuWithTriggerButton_Text",
      children: children
    })
  });
};

export var NotificationMenuWithTriggerButton = function NotificationMenuWithTriggerButton() {
  var _useRouter = useRouter(),
      push = _useRouter.push;

  var scrollRef = useRef(null);

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useState = useState(NotificationFilterKeys.ALL),
      notificationFilter = _useState[0],
      setNotificationFilter = _useState[1];

  var _useQuery = useQuery({
    queryKey: ['getUnreadCount'],
    queryFn: function queryFn() {
      return services.user.getUnreadCount();
    },
    refetchInterval: ONE_MINUTE
  }),
      unreadCountData = _useQuery.data,
      unreadCountRefetch = _useQuery.refetch;

  var _useInfiniteQuery = useInfiniteQuery({
    queryKey: ['getNotifications', notificationFilter],
    queryFn: function queryFn(_ref2) {
      var _ref2$pageParam = _ref2.pageParam,
          pageParam = _ref2$pageParam === void 0 ? undefined : _ref2$pageParam;
      return services.notification.getNotifications({
        unread: notificationFilter === NotificationFilterKeys.UNREAD ? true : undefined,
        before: pageParam
      });
    },
    getNextPageParam: getNextPageParam,
    initialPageParam: undefined,
    refetchInterval: ONE_MINUTE
  }),
      notificationsData = _useInfiniteQuery.data,
      isFetchingNextPage = _useInfiniteQuery.isFetchingNextPage,
      fetchNextPage = _useInfiniteQuery.fetchNextPage,
      hasNextPage = _useInfiniteQuery.hasNextPage,
      notificationsRefetch = _useInfiniteQuery.refetch;

  var markNotificationAsReadMutation = useMutation({
    mutationFn: services.notification.setRead,
    onSuccess: function onSuccess() {
      unreadCountRefetch();
      notificationsRefetch();
    }
  });
  var notifications = R.pipe(R.propOr([], 'pages'), R.flatten, getAssets, R.uniqBy(R.prop('id')), R.sortBy(R.prop('created_at')), R.reverse)(notificationsData);
  var rowVirtualizer = useVirtualizer({
    count: hasNextPage ? notifications.length + 1 : notifications.length,
    getScrollElement: function getScrollElement() {
      return scrollRef.current;
    },
    estimateSize: function estimateSize() {
      return 100;
    },
    overscan: 5
  });
  useEffect(function () {
    var _reverse = _toConsumableArray(rowVirtualizer.getVirtualItems()).reverse(),
        _reverse2 = _slicedToArray(_reverse, 1),
        lastItem = _reverse2[0];

    if (!lastItem) {
      return;
    }

    if (lastItem.index >= notifications.length - 1 && hasNextPage && !isFetchingNextPage) {
      fetchNextPage();
    }
  }, [hasNextPage, fetchNextPage, notifications.length, isFetchingNextPage, rowVirtualizer.getVirtualItems()]);
  var handleNotificationFilterClick = useCallback(function (key) {
    return function () {
      setNotificationFilter(key);
    };
  }, [setNotificationFilter]);
  var handleNotificationClick = useCallback(function (notification) {
    return function () {
      var payload = [notification.id];
      var asset = notification.asset,
          record_type = notification.record_type,
          record_client_id = notification.record_client_id,
          record_id = notification.record_id,
          category = notification.category;

      if (category === 'my_info') {
        push("".concat(MenuID.client_mgmt, "?clientID=").concat(record_id, "&tab=").concat(ClientProfileTabType.measurement, "&pageMode=view_all"));
        return;
      }

      if (asset) {
        payload = notifications.filter(function (n) {
          return n.record_id === notification.record_id && n.record_type === notification.record_type;
        }).map(function (n) {
          return n.id;
        });
      }

      markNotificationAsReadMutation.mutateAsync(payload);

      if (asset._parentDate) {
        push("".concat(MenuID.client_mgmt, "?clientID=").concat(record_client_id, "&tab=").concat(ClientProfileTabType.dietRecord, "&date=").concat(asset._parentDate, "&noteID=").concat(record_id, "&pageMode=").concat(NOTE_PAGE_MODE.VIEW_ALL));
      }
    };
  }, [markNotificationAsReadMutation, notifications, push]);
  return /*#__PURE__*/_jsxs(Menu, {
    isLazy: true,
    lazyBehavior: "keepMounted",
    e2eid: "components_NotificationMenuWithTriggerButton_Menu",
    children: [/*#__PURE__*/_jsxs(Box, {
      pos: "relative",
      e2eid: "components_NotificationMenuWithTriggerButton_Box",
      children: [/*#__PURE__*/_jsx(MenuButton, {
        as: IconButton,
        icon: /*#__PURE__*/_jsx(NotificationIcon, {
          boxSize: "6",
          e2eid: "components_NotificationMenuWithTriggerButton_NotificationIcon"
        }),
        variant: "ghost",
        color: "#6E6B7B",
        e2eid: "components_NotificationMenuWithTriggerButton_MenuButton"
      }), !!(unreadCountData !== null && unreadCountData !== void 0 && unreadCountData.totalUnreadCount) && /*#__PURE__*/_jsx(NotificationBadge, {
        e2eid: "components_NotificationMenuWithTriggerButton_NotificationBadge",
        children: unreadCountData.totalUnreadCount > 99 ? '99+' : unreadCountData.totalUnreadCount
      })]
    }), /*#__PURE__*/_jsxs(MenuList, {
      p: "0",
      maxH: "xl",
      minW: "xs",
      overflow: "auto",
      ref: scrollRef,
      e2eid: "components_NotificationMenuWithTriggerButton_MenuList",
      children: [/*#__PURE__*/_jsxs(HStack, {
        spacing: "1",
        p: "2",
        pos: "sticky",
        top: "0",
        bg: "white",
        zIndex: 2,
        e2eid: "components_NotificationMenuWithTriggerButton_HStack",
        children: [/*#__PURE__*/_jsx(TitleHeader, {
          e2eid: "components_NotificationMenuWithTriggerButton_TitleHeader",
          children: t('common:notification', '通知')
        }), Object.values(NotificationFilterKeys).map(function (key) {
          return /*#__PURE__*/_jsx(Button, {
            rounded: "20",
            size: "sm",
            variant: notificationFilter === key ? 'solid' : 'outline',
            borderWidth: "1px",
            onClick: handleNotificationFilterClick(key),
            e2eid: "components_NotificationMenuWithTriggerButton_Button",
            children: t("common:NotificationFilter.".concat(key), NotificationFilter[key])
          }, key);
        })]
      }), /*#__PURE__*/_jsx(Stack, {
        spacing: "0",
        h: "".concat(rowVirtualizer.getTotalSize(), "px"),
        w: "full",
        pos: "relative",
        e2eid: "components_NotificationMenuWithTriggerButton_Stack",
        children: rowVirtualizer.getVirtualItems().map(function (virtualRow) {
          var isLoaderRow = virtualRow.index > notifications.length - 1;
          var notification = notifications[virtualRow.index];

          if (isLoaderRow) {
            return /*#__PURE__*/_jsx(MenuItem, {
              minH: "48px",
              pos: "absolute",
              t: "0",
              l: "0",
              r: "0",
              w: "full",
              h: "".concat(virtualRow.size, "px"),
              transform: "translateY(".concat(virtualRow.start, "px)"),
              e2eid: "components_NotificationMenuWithTriggerButton_MenuItem",
              children: !hasNextPage ? 'Loading...' : 'Load more'
            }, "loader");
          }

          return /*#__PURE__*/_jsxs(MenuItem, {
            minH: "48px",
            as: HStack,
            spacing: "2",
            borderTop: "1px solid #D1D4D9",
            _hover: {
              cursor: 'pointer'
            },
            bg: !notification.read ? '#D6ECF0' : 'white',
            pos: "absolute",
            t: "0",
            l: "0",
            r: "0",
            w: "full",
            h: "".concat(virtualRow.size, "px"),
            transform: "translateY(".concat(virtualRow.start, "px)"),
            onClick: handleNotificationClick(notification),
            e2eid: "components_NotificationMenuWithTriggerButton_MenuItem_13",
            children: [/*#__PURE__*/_jsx(Avatar, {
              src: notification.image_url,
              name: notification.sender_name,
              e2eid: "components_NotificationMenuWithTriggerButton_Avatar"
            }), /*#__PURE__*/_jsx(HStack, {
              w: "20",
              e2eid: "components_NotificationMenuWithTriggerButton_HStack",
              children: /*#__PURE__*/_jsx(Tooltip, {
                label: notification.sender_name,
                e2eid: "components_NotificationMenuWithTriggerButton_Tooltip",
                children: /*#__PURE__*/_jsx(Text, {
                  isTruncated: true,
                  e2eid: "components_NotificationMenuWithTriggerButton_Text",
                  children: notification.sender_name
                })
              })
            }), /*#__PURE__*/_jsxs(Stack, {
              w: "50",
              e2eid: "components_NotificationMenuWithTriggerButton_Stack",
              children: [/*#__PURE__*/_jsx(Text, {
                e2eid: "components_NotificationMenuWithTriggerButton_Text",
                children: notification.title
              }), notification.created_at && /*#__PURE__*/_jsx(Text, {
                fontSize: "sm",
                color: "#888",
                e2eid: "components_NotificationMenuWithTriggerButton_Text_20",
                children: getHumanizedDateFromNow(notification.created_at)
              })]
            })]
          }, notification.id);
        })
      })]
    })]
  });
};